

import React, { useState, useEffect, useRef } from "react";

const ActDropdown = ({
    label = "Act",
    availableActs = [],
    selectedActs,
    setSelectedActs,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen((prev) => !prev);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggleAct = (act) => {
        if (selectedActs.includes(act)) {
            setSelectedActs(selectedActs.filter((a) => a !== act));
        } else {
            setSelectedActs([...selectedActs, act]);
        }
    };

    const isAllSelected = selectedActs?.length === availableActs?.length;

    const filteredActs = availableActs.filter((act) =>
        act.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {isOpen && (
                <div
                    onClick={() => setIsOpen(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "transparent",
                        zIndex: 998,
                    }}
                />
            )}

            <div
                className="dropdown"
                ref={dropdownRef}
                style={{ position: "relative", zIndex: isOpen ? 999 : 1, width: "fit-content" }}
            >
                <button
                    className="btn"
                    type="button"
                    onClick={toggleDropdown}
                    style={{
                        border: isOpen || selectedActs?.length > 0
                            ? "1px solid rgba(79, 70, 229, 0.5)"
                            : "1px solid #E4E4E7",
                        backgroundColor: isOpen || selectedActs?.length > 0
                            ? "#F3F4F6"
                            : "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxShadow: isOpen || selectedActs?.length > 0
                            ? "0px 0px 4px rgba(79, 70, 229, 0.5)"
                            : "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        transition: "box-shadow 0.2s ease-in-out",
                        minWidth: "100px",
                        width: "auto",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                >
                    <span
                        style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px",
                            display: "inline-block",
                            fontSize:"12px"
                        }}
                    >
                        {label}
                    </span>
                    <span style={{ fontSize: "12px", marginLeft: "8px" }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="black"
                            viewBox="0 0 16 16"
                        >
                            <path
                                fillRule="evenodd"
                                d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                            />
                        </svg>
                    </span>
                </button>

                {isOpen && (
                    <div
                        className="dropdown-menu show p-2 shadow"
                        style={{
                            width: "350px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            backgroundColor: "#fff",
                            borderRadius: "5px",
                            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            zIndex: 1000,
                        }}
                    >

                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                        

                        <div
                            style={{
                                maxHeight: "200px",       
                                overflowY: "auto",        
                                border: "1px solid #ccc", 
                                borderRadius: "5px",
                            }}
                        >
                            <div className="list-group border-0">
                                {filteredActs.length > 0 && (
                                    <label
                                        className="list-group-item d-flex align-items-center"
                                        style={{ fontSize: "12px" }}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={isAllSelected}
                                            onChange={() =>
                                                setSelectedActs(isAllSelected ? [] : availableActs)
                                            }
                                            style={{ width: "16px", height: "16px" }}
                                        />
                                        Select All
                                    </label>
                                )}

                                {filteredActs.length > 0 ? (
                                    filteredActs.map((act, idx) => (
                                        <label
                                            key={idx}
                                            className="list-group-item d-flex align-items-center"
                                            style={{
                                                fontSize: "13px",
                                                lineHeight: "1.2",
                                                paddingTop: "6px",
                                                paddingBottom: "6px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={selectedActs.includes(act)}
                                                onChange={() => toggleAct(act)}
                                                style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    flexShrink: 0,
                                                    cursor: "pointer",
                                                }}
                                            />
                                            {act}
                                        </label>
                                    ))
                                ) : (
                                    <div className="text-muted text-center mt-2">No matches found</div>
                                )}
                            </div>
                        </div>

                    </div>
                )}
            </div>
        </>
    );
};

export default ActDropdown;
